<template>
    <div class="content-wrapper">

        <app-table
            id="course-lesson-table"
            :options="options"
            @action="triggerActions"
        />


    </div>
</template>

<script>
import CourseLessonMixin from "../../../../Mixins/Learning/CourseLessonMixin";
import {mapState} from "vuex";
import {urlGenerator} from "../../../../../../common/Helper/AxiosHelper";
import {LESSONWEB} from "../../../../../Config/ApiUrl";

export default {
    name: "CourseLessons",
    mixins: [CourseLessonMixin],
    props: ['props'],
    data() {
        return {
            lesson: '',
            lessonsId: '',
            lessons: [],
            courseId:''
        }
    },
    created() {
        this.courseId = this.props.courseId;
    },
    methods: {
        triggerActions(row, action, active) {
            this.lessonId = row.id;
            this.promptIcon = action.icon;
            this.modalClass = action.modalClass;
            this.promptSubtitle = action.promptSubtitle;
            if (action.key === 'view_details') {
                window.location = urlGenerator(`${LESSONWEB}/${row.id}`)
                // Add logic to handle view details action
            }
        },
    },
    watch: {
        isLessonModalActive: function (value) {
            if (!value) {
                this.selectedUrl = '';
            }
        },
    },
    computed: {
        ...mapState({
            course: state => {},
            loader: state => state.loading,
        }),
    }
}
</script>
